// Configurações de API
export const API_CONFIG = {
  API_URL: import.meta.env.VITE_API_URL || 'http://localhost:3001',
  TIMEOUT: 1000000,
  // Timeout para upload de documentos (processamento pode demorar)
  UPLOAD_TIMEOUT: 300000, // 5 minutos (300000ms)
  RETRY_ATTEMPTS: 3,
  RETRY_DELAY: 1000
} as const


